export class stringUtil {
  static isEmptyOrUndefined(value: string): boolean {
    return value === undefined || value === '';
  }
}
